<template>
	<div class="product-controller-page">
		<ManagingSection>
			<ManagingBox title="상태">
				<RadioList
					:value="isDisplay"
					:radio-list="isDisplayList"
					@input="mutationSingle('isDisplay', $event)"
				/>
			</ManagingBox>
			<ManagingBox title="단종여부">
				<RadioList
					:value="isDiscontinue"
					:radio-list="isDiscontinueList"
					@input="mutationSingle('isDiscontinue', $event)"
				/>
			</ManagingBox>
			<ManagingBox title="달파노출여부">
				<RadioList
					:value="isDisplayDalpha"
					:radio-list="isDisplayDalphaList"
					@input="mutationSingle('isDisplayDalpha', $event)"
				/>
			</ManagingBox>

			<ManagingBox v-if="isInquiry" title="제품 번호">{{
				idProduct
			}}</ManagingBox>

			<ManagingBox title="제품그룹">
				<div class="flex-row">
					<ProductSearcher2
						ref="product_selector"
						size="80"
						mode="search_view"
						:idProduct="groupId"
						:disabled="idProduct && groupId == idProduct"
						@change="onSelectProduct"
					/>
					<button
						v-if="original.groupId"
						type="button"
						class="btn"
						style="margin-top: 3px; margin-left: 5px"
						v-text="'제품그룹 조회'"
						@click="openProductGroupModal"
					/>
				</div>
				<p class="form-alert">
					제품그룹을 원하는 최초 등록된 제품를 선택/입력하면 그룹
					처리됩니다.
				</p>
			</ManagingBox>

			<ManagingBox v-if="isInquiry" title="수정일">{{
				updateInfo
			}}</ManagingBox>

			<ManagingBox v-if="isInquiry" title="등록일">{{
				createInfo
			}}</ManagingBox>

			<ManagingBox title="브랜드명">
				<SearchBrand
					@change="idBrandChange"
					ref="SearchBrand"
					searcher-placeholder="브랜드명를 입력하세요"
					selected-placeholder="브랜드를 선택해 주세요"
					:use-last-brand="true"
					:show-if-is-display="true"
				/>
			</ManagingBox>

			<ManagingBox title="스토어">
				<CheckboxList
					:value="brandTypeList"
					:checkboxList="storeListOrigin"
					key-name="idBrandType"
					value-name="brandTypeName"
					@input="mutationSingle('brandTypeList', $event)"
				/>
			</ManagingBox>
			<ManagingBox title="제품명">
				<input
					type="text"
					placeholder="제품명을 입력하세요"
					@input="mutationSingle('productTitle', $event.target.value)"
					:value="productTitle"
				/>
			</ManagingBox>
			<ManagingBox title="카테고리">
				<ProductCategorySet ref="categorySet" />
			</ManagingBox>
			<ManagingBox title="발매년도">
				<DateBox
					:value="releaseDate"
					type="month"
					@input="mutationSingle('releaseDate', $event)"
				/>
			</ManagingBox>
			<ManagingBox title="사진">
				<ImageUploader
					ref="imageUploader"
					group="product"
					:image-size-limit="imageSizeLimit"
					:file-size-limit="imageFileSizeLimit"
					@upload="onImageUpload"
				/>
			</ManagingBox>
			<ManagingBox title="용량">
				<input
					type="text"
					placeholder="용량을 입력하세요. ex) 50g*2, 20ml"
					@input="mutationSingle('volume', $event.target.value)"
					:value="volume"
					@blur="checkLanguage"
					ref="refVolume"
				/>
			</ManagingBox>
			<ManagingBox title="가격">
				<InputText
					class="product-controller__price-input"
					@input="mutationSingle('price', $event)"
					mode="number"
					:comma="true"
					:prop-value="price"
					:input-width="100"
					input-width-unit="%"
					placeholder="가격을 입력하세요. ex)2000 , 10000"
				/>
			</ManagingBox>
			<ManagingBox title="컬러">
				<textarea
					:value="colors"
					rows="6"
					placeholder="컬러를 쉼표로 구분하여 입력하세요. ex) 베어 누드, 페탈 누드"
					@input="mutationSingle('colors', $event.target.value)"
				/>
			</ManagingBox>
			<ManagingBox title="타입">
				<textarea
					:value="etcs"
					rows="6"
					placeholder="타입을 쉼표로 구분하여 입력하세요. ex) 50ml, 100ml"
					@input="mutationSingle('etcs', $event.target.value)"
				/>
			</ManagingBox>
			<ManagingBox title="제품 설명">
				<textarea
					class="product-controller__product-text"
					placeholder="제품 설명을 입력하세요."
					@input="mutationSingle('productText', $event.target.value)"
					:value="productText"
				></textarea>
			</ManagingBox>
			<ManagingBox title="성분 목록">
				<IngredientList />
			</ManagingBox>
			<template v-if="isInquiry">
				<ManagingBox title="기타 정보">
					<button class="btn" type="button" @click="moveReview">
						리뷰 이동
					</button>
					<ul class="product-inquiry__etc">
						<li class="product-inquiry__etc__item">
							<p>평점</p>
							<router-link
								class="product-inquiry__etc__item__content--link"
								type="button"
								:to="`/review/list?idProduct=${this.idProduct}`"
								>{{ ratingAvg }} ({{
									commentCount
								}}건)</router-link
							>
						</li>
						<li class="product-inquiry__etc__item">
							<p>조회수</p>
							<p class="product-inquiry__etc__item__content">
								{{ readCount }}
							</p>
						</li>
						<li class="product-inquiry__etc__item">
							<p>위시 리스트</p>
							<button
								class="product-inquiry__etc__item__content--link"
								type="button"
								@click="linkToRegisterList"
							>
								{{ wishCount }}
							</button>
						</li>
						<li class="product-inquiry__etc__item">
							<p>인기도</p>
							<p class="product-inquiry__etc__item__content">
								{{ productScore }}
							</p>
						</li>
					</ul>
					<p class="product-inquiry__award__title">
						수상 정보 (총 {{ awardList.length }}회)
					</p>
					<table
						class="product-inquiry__award"
						v-if="awardList.length > 0"
					>
						<tr v-for="awardItem in awardList" :key="awardItem.id">
							<td>{{ awardItem.hitText }}</td>
							<td>{{ awardItem.parsedCategory }}</td>
							<td>{{ awardItem.parsedSortKey }}</td>
						</tr>
					</table>
				</ManagingBox>
			</template>
			<ManagingBox title="코멘트">
				<MemoBox
					v-if="idProduct"
					ref-type="product"
					:ref-id="idProduct"
				/>
				<div class="product-inquiry__comment-list" v-else>
					<div class="product-inquiry__comment">
						<textarea
							type="text"
							placeholder="내용을 입력하세요."
							@input="changeComment($event)"
							:value="comment"
							:disabled="isComment"
						/>
						<button
							class="btn blue"
							type="button"
							@click="commentRegister"
						>
							입력
						</button>
					</div>
					<div
						class="product-inquiry__register-comment"
						v-if="isComment"
					>
						<p>{{ memo }}</p>
						<div class="product-inquiry__button-list">
							<button
								type="button"
								class="btn btn-cell__box__button"
								v-text="'수정'"
								@click="modifyComment"
							/>
							<button
								type="button"
								class="btn-delete--only-icon"
								@click="deleteComment"
							/>
						</div>
					</div>
				</div>
			</ManagingBox>
		</ManagingSection>
	</div>
</template>

<script>
	import util from '@/util.js';
	import { mapState } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import SearchBrand from '@/components/SearchBrand.vue';
	import CheckboxList from '@/components/CheckboxList';
	import ProductCategorySet from '@/components/product/ProductCategorySet.vue';
	import DateBox from '@/components/DateBox';
	import ProductImgUploader from '@/components/product/ProductImgUploader.vue';
	import IngredientList from '@/components/product/IngredientList.vue';
	import MemoBox from '@/components/MemoBox.vue';
	import InputText from '@/components/InputText.vue';
	import ImageUploader from '@/components/ImageUploader';
	import ProductSearcher2 from '@/components/ProductSearcher2';

	export default {
		name: 'ProductController',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			SearchBrand,
			CheckboxList,
			ProductCategorySet,
			DateBox,
			ProductImgUploader,
			IngredientList,
			MemoBox,
			InputText,
			ImageUploader,
			ProductSearcher2,
		},
		data() {
			return {
				imageSizeLimit: {
					width: 500,
					height: 500,
					previewWidth: 120,
					type: 'fit',
				},
				imageFileSizeLimit: 0.3,
				isComment: false,
				comment: '',
			};
		},
		computed: {
			...mapState('ProductController', [
				'isInquiry',
				'idProduct',
				'isDisplayList',
				'isDisplay',
				'isDiscontinueList',
				'isDiscontinue',
				'isDisplayDalphaList',
				'isDisplayDalpha',
				'storeListOrigin',
				'brandTypeList',
				'productTitle',
				'releaseDate',
				'volume',
				'price',
				'colorType',
				'colors',
				'etcs',
				'productText',
				'ratingAvg',
				'commentCount',
				'readCount',
				'wishCount',
				'productScore',
				'awardList',
				'updateInfo',
				'createInfo',
				'factorsInsertedDate',
				'factorsModifiedDate',
				'groupId',
				'productGroupList',
				'original',
				'memo',
			]),
		},
		created() {
			this.$store.dispatch('ProductController/initControllerData');
		},
		methods: {
			refresh() {
				if (!confirm('작성한 내용을 삭제하시겠습니까?')) return;
				window.location.reload();
			},
			linkToRegisterList() {
				this.$router.push(
					`/register/activated-list?wishIdProduct=${this.idProduct}`
				);
			},
			mutationSingle(key, value) {
				this.$store.commit('ProductController/stateChange', [
					{ key, value },
				]);
			},
			moveReview() {
				this.$store.commit('modal/toggleModal', {
					id: 'ProductReviewMove',
				});
			},
			async setBrandStore(idBrand) {
				if (null === idBrand) return;
				const { data } = await this.$axiosAdmin2.get(
					`/api/brands/brandType/${idBrand}`
				);
				if (data.data.length < 1) return;
				const brandTypeList = data.data
					.map(item => item.idBrandType)
					.filter(idBrandType => {
						return this.storeListOrigin.some(
							item => item.idBrandType === idBrandType
						);
					});
				this.mutationSingle('brandTypeList', brandTypeList);
			},
			idBrandChange(changes) {
				this.mutationSingle('idBrand', changes.idBrand);
				this.setBrandStore(changes.idBrand);
			},
			onImageUpload(imageDto) {
				this.$store.commit('ProductController/setImgDto', imageDto);
			},
			openProductGroupModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'ProductGroup',
					contsTitle: '제품 그룹 목록',
					params: {
						productGroupList: this.productGroupList,
						idProduct: this.idProduct,
					},
				});
			},
			async onSelectProduct(product) {
				if (product) {
					if (
						!(
							this.productGroupList &&
							this.productGroupList.length
						) &&
						this.idProduct == product.idProduct
					) {
						this.$refs.product_selector.init();
						await this.mutationSingle('groupId', null);
						return alert(
							'해당 제품은 그룹제품으로 지정할 수 없습니다.'
						);
					}

					let rs = await this.$axiosAdminJS.get(
						`/product/can-group-id/${product.idProduct}`
					);
					if (rs.data.result) {
						await this.mutationSingle('groupId', product.idProduct);
					} else {
						this.$refs.product_selector.init();
						await this.mutationSingle('groupId', null);
						alert('해당 제품은 그룹제품으로 지정할 수 없습니다.');
					}
				} else {
					await this.mutationSingle('groupId', null);
				}
			},
			checkLanguage() {
				const korean = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;
				if (korean.test(this.volume)) {
					alert('한글은 입력이 불가능합니다.');
					this.$refs.refVolume.value = '';
					this.mutationSingle('volume', '');
					this.$refs.refVolume.focus();
				}
			},
			changeComment($event) {
				this.mutationSingle('memo', $event.target.value);
				if (this.memo.length === 0) {
					this.mutationSingle('isNewComment', false);
				} else {
					this.mutationSingle('isNewComment', true);
				}
			},
			commentRegister() {
				this.comment = this.memo;
				if (this.comment.length === 0) {
					alert('입력된 코멘트가 없습니다.');
					return;
				}
				this.isComment = true;
				this.comment = '';
				this.mutationSingle('isNewComment', false);
			},

			modifyComment() {
				this.isComment = false;
				this.comment = this.memo;
				this.mutationSingle('isNewComment', true);
			},

			deleteComment() {
				this.isComment = false;
				this.mutationSingle('memo', '');
			},
		},
	};
</script>

<style lang="scss" scoped>
	.product-inquiry__etc {
		margin: 16px 0 0 0;

		&:after {
			content: '';
			display: block;
			clear: both;
		}
	}

	.product-inquiry__etc__item {
		float: left;
		display: block;
		text-align: center;

		& + .product-inquiry__etc__item {
			margin-left: 14px;
		}
	}

	.product-inquiry__etc__item__content {
		padding: 8px;
		font-weight: 700;
	}

	.product-inquiry__etc__item__content--link {
		@extend .product-inquiry__etc__item__content;

		cursor: pointer;
		color: $btn-blue;

		&:hover {
			text-decoration: underline;
		}
	}

	.product-inquiry__award__title {
		margin: 16px 0 0 0;
		font-weight: 700;
	}

	.product-inquiry__award {
		width: auto;
		margin: 8px 0 0 0;

		td {
			padding: 4px;

			& + td {
				padding-left: 14px;
			}
		}
	}

	.product-controller-page .product-controller__price-input {
		display: block;
		width: 100%;
	}

	.product-controller__product-text {
		height: 320px;
	}

	.product-inquiry__comment-list {
		width: 100%;
	}

	.product-inquiry__comment {
		display: flex;
		width: 100%;
		gap: 10px;
		align-items: center;
	}

	.product-inquiry__register-comment {
		width: 100%;
		border: solid 1px #dfe6ee;
		margin-top: 20px;
		padding: 20px;
		display: flex;
		justify-content: space-between;
	}

	.product-inquiry__button-list {
		display: flex;
		gap: 10px;
	}
</style>
